import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Input, Button} from 'react-bootstrap'
import {replace} from '../../core/extract'
import {max} from '../../core/mathz'
import {connectForm} from '../../core/redux/form'
import Rating from '../../core/components/Rating'
import Icon from '../../core/components/Icon'
import {AnswerAction} from '../models'
import {ANSWER_ACTION_UPDATED, sendAnswerAction, updateAnswerAction, loadAnswerStream} from '../actions'
import i18n from '../i18n'
import style from './AnswerForm.less'

class AnswerForm extends Component {
    static propTypes = {
        ticket: PropTypes.object.isRequired
    }

    constructor(props) {
        super(props)

        this.state = {
        }
    }

    componentWillMount() {
        // data already loaded by SatisfactionButton
        const {dispatch, campaign, ticket} = this.props

        const maxScore = campaign && max({source: campaign.notationScale, identify: (s) => s.position})
        this.setState({maxScore})

        dispatch(updateAnswerAction({ticketUid: ticket.uid, answers: campaign && campaign.questions.map(() => null)}))
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.campaign != this.props.campaign) {
            const {dispatch, campaign} = nextProps

            const maxScore = campaign && max({source: campaign.notationScale, identify: (s) => s.position})
            this.setState({maxScore})

            dispatch(updateAnswerAction({answers: campaign && campaign.questions.map(() => null)}))
        }

        if (nextProps.ticket != this.props.ticket) {
            const {dispatch, ticket} = nextProps
            dispatch(updateAnswerAction({ticketUid: ticket.uid, answers: null}))
        }
    }

    sendAction() {
        const {dispatch} = this.props

        return dispatch(sendAnswerAction()).then(() => {
            return dispatch(loadAnswerStream())
        })
    }

    validate() {
        const {form} = this.props
        return form.validate()
    }

    isValid() {
        const {form} = this.props
        return form.isValid()        
    }

    _openComment(event, openedComment) {
        event.preventDefault()
        this.setState({openedComment})
    }

    render() {
        const {dispatch, form, action, stream, campaign, ticket, ...others} = this.props
        const {maxScore, openedComment} = this.state

        const answer = stream[0]

        const scoreField = (field, questionUid, questionIndex) => {
            const value = field.value && field.value[questionIndex] && field.value[questionIndex].score

            function onChange(score) {
                const nextValue = field.value && [...field.value] || []
                nextValue[questionIndex] = {...nextValue[questionIndex], questionUid, score}
                field.onChange(nextValue)
            }

            return {value, onChange}
        }

        const commentField = (field, questionUid, questionIndex) => {
            const value = field.value && field.value[questionIndex] && field.value[questionIndex].comment

            function onChange(event) {
                const comment = event.target.value || null

                const nextValue = field.value && [...field.value] || []
                nextValue[questionIndex] = {...nextValue[questionIndex], questionUid, comment}
                field.onChange(nextValue)
            }

            return {value, onChange}
        }

        return campaign && (
            <form className='form-horizontal'
                {...others}>
                {campaign.questions.slice().reverse().map((question, questionIndex) => (
                    <div
                        key={question.uid}>
                        <Input
                            labelClassName='col-sm-3'
                            wrapperClassName='col-sm-9'
                            label={question.text}>
                            <Rating
                                label={i18n.score}
                                range={maxScore}
                                {...scoreField(form.answers(), question.uid, questionIndex)} />
                        </Input>
                        {(openedComment == questionIndex || (action && action.answers[questionIndex] && action.answers[questionIndex].comment)) && (
                            <Input
                                labelClassName='col-sm-3'
                                wrapperClassName='col-sm-9'
                                type='textarea'
                                label=' '
                                placeholder={i18n.comment}
                                {...commentField(form.answers(), question.uid, questionIndex)} />
                        )}
                        {!(openedComment == questionIndex || (action && action.answers[questionIndex] && action.answers[questionIndex].comment)) && (
                            <div className={style.action}>
                                <a
                                    href=''
                                    onClick={(e) => this._openComment(e, questionIndex)}>
                                    <Icon icon='plus' size='xs' />
                                    <span>{i18n.commentz}</span>
                                </a>
                            </div>
                        )}
                    </div>
                ))}
                <Input
                    labelClassName='col-sm-3'
                    wrapperClassName='col-sm-9'
                    type='textarea'
                    label={i18n.globalComment}
                    placeholder={i18n.comment}
                    {...form.comment()} />
            </form>
        )
    }
}

AnswerForm = connectForm({
    target: 'action',
    schema: AnswerAction.schema,
    action: ANSWER_ACTION_UPDATED
})(AnswerForm)

AnswerForm = connect((state) => ({
    stream: state.satisfaction.answer.stream,
    campaign: state.satisfaction.campaign.campaign,
    action: state.satisfaction.answerAction
}), null, null, {withRef: true})(AnswerForm)

class AnswerFormWrapper extends Component {

    sendAction() {
        const {answerForm} = this.refs
        return answerForm && answerForm.getWrappedInstance().getWrappedInstance().sendAction()
    }

    validate() {
        const {answerForm} = this.refs
        return answerForm && answerForm.getWrappedInstance().getWrappedInstance().validate()
    }

    isValid() {
        const {answerForm} = this.refs
        return answerForm && answerForm.getWrappedInstance().getWrappedInstance().isValid()
    }

    render() {
        return <AnswerForm ref='answerForm' {...this.props} />
    }
}

export default AnswerFormWrapper


// WEBPACK FOOTER //
// ./lib/satisfaction/components/AnswerForm.js